import { Input } from '@on3/ui-lib/components/Input/Input';
import { filterNumber } from '@on3/ui-lib/utils/filters';
import {
  formatHeightToNumber,
  formatHeightToString,
} from '@on3/ui-lib/utils/vitals';
import { ProfileDetailsContext } from 'components/Modals/Player/Details';
import { useContext, useEffect, useState } from 'react';

import styles from './DetailsVitals.module.scss';

export const DetailsVitals = () => {
  const { values, errors, handleUpdate } = useContext(ProfileDetailsContext);

  const [state, setState] = useState({
    feet: formatHeightToString(values.height.value, 'feet'),
    inches: formatHeightToString(values.height.value, 'inches'),
    weight: String(values.weight.value ?? ''),
  });

  useEffect(() => {
    handleUpdate(
      'height.value',
      String(
        formatHeightToNumber(`${state.feet || 0}-${state.inches || 0}`) || '',
      ),
    );
  }, [handleUpdate, state.feet, state.inches]);

  useEffect(() => {
    handleUpdate('weight.value', state.weight);
  }, [handleUpdate, state.weight]);

  return (
    <div className={styles.block}>
      <fieldset className={styles.height}>
        <legend>Height</legend>
        <div className={styles.fields}>
          <Input
            label="Feet"
            name="feet"
            onChange={(e) =>
              setState((curr) => ({
                ...curr,
                feet: filterNumber(e.target.value),
              }))
            }
            srLabel
            step="1"
            suffix="ft"
            type="number"
            value={state.feet}
          />
          <Input
            label="Inches"
            name="inches"
            onChange={(e) =>
              setState((curr) => ({
                ...curr,
                inches: filterNumber(e.target.value),
              }))
            }
            srLabel
            step="0.5"
            suffix="in"
            type="number"
            value={state.inches}
          />
        </div>
      </fieldset>
      <Input
        error={errors['weight.value']}
        label="Weight"
        name="weight"
        onChange={(e) =>
          setState((curr) => ({
            ...curr,
            weight: filterNumber(e.target.value),
          }))
        }
        step="0.1"
        suffix="lbs"
        type="number"
        value={state.weight}
      />
    </div>
  );
};
